import React, { useState, useEffect } from "react";
import { isAuthenticated } from "../services/auth";
import { Link } from "react-router-dom";
import logo from "../assets/images/logo.png";
import { useDispatch } from "react-redux";
import { loginAction } from "../redux/actions/loginAction";
import { showFormErrors } from "../utils/commonFunctions";
import { allValidations } from "../utils/formValidations";
import { CustomForm, CustomInput, CustomPassword } from "../shared/Input/AllInputs";
import PrimaryButton from "../shared/Button/PrimaryButton";
import CustomCard from "../shared/Card/CustomCard";

const Login = ({ history }) => {
    const dispatch = useDispatch();
    useEffect(() => {
        document.documentElement.style.fontSize = 14 + "px";
        if (isAuthenticated()) {
            history.push("/dashboard");
        }
    }, [history]);

    const [loading, setLoading] = useState(false);

    const [data, setData] = useState({
        email: "",
        loginPassword: "",
    });

    const handleChange = ({ name, value }) => {
        const formErrors = allValidations(name, value, data);
        setData((prev) => ({ ...prev, [name]: value, formErrors }));
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        if (showFormErrors(data, setData)) {
            dispatch(loginAction(data, setLoading, history));
        }
    };

    return (
        <div className="flex justify-content-center w-full min-h-screen align-items-center">
            <CustomCard className="bg-white border-round-2xl w-4" childrenClassName="border-round-2xl" backable={false}>
                <div className="text-center">
                    <img src={logo} alt="logo" style={{ width: "20%" }} />
                </div>
                <h2>Login</h2>
                <CustomForm>
                    <CustomInput col="12" data={data} onChange={handleChange} name="email" label="Email" required />
                    <CustomPassword col="12" data={data} onChange={handleChange} name="loginPassword" label="Password" required />
                    <PrimaryButton label="Login" loading={loading} onClick={handleSubmit} />
                </CustomForm>
                <div className="text-right mt-4">
                    <Link to="/forgetpassword" className="text-decoration-none">
                        &nbsp;
                        <span className="h6 navyColor font_bolder text-right">Forgot Password?</span>
                    </Link>
                </div>
            </CustomCard>
        </div>
    );
};
export default Login;
